import { http } from '../index';
import { dashboardModifier } from '../formatters';
import { downloadFileFromResponse } from '../helpers';

export const getDashboardStatistics = params => {
  return http
    .get('/dashboard', {
      params,
    })
    .then(res => dashboardModifier(res.data))
    .catch(error => error.response.data);
};

export const exportDashboardStatistics = params => {
  return http
    .get('/dashboard/export', {
      params,
      responseType: 'blob',
    })
    .then(downloadFileFromResponse)
    .catch(error => error.response.data);
};

